function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import velocity from 'velocity-animate';
import 'velocity-animate/velocity.ui';
var Header = /*#__PURE__*/function () {
  function Header() {
    var _this = this;
    _classCallCheck(this, Header);
    this.state = {
      fixed: false
    };
    this.toggleFixed();
    window.addEventListener('scroll', function () {
      _this.toggleFixed();
    });
    this.toggleMegaMenu();
  }
  _createClass(Header, [{
    key: "toggleFixed",
    value: function toggleFixed() {
      if (window.pageYOffset > (window.innerWidth >= 768 ? 50 : 40) && !this.state.fixed) {
        this.state.fixed = true;
        Header.toggleFixedClasses();
      } else if (window.pageYOffset < (window.innerWidth >= 768 ? 50 : 40) && this.state.fixed) {
        this.state.fixed = false;
        Header.toggleFixedClasses();
      }
    }
  }, {
    key: "toggleMegaMenu",
    value: function toggleMegaMenu() {
      var _this2 = this;
      this.triggers = Array.from(document.querySelectorAll('.js-mm-trigger'));
      this.megaMenus = Array.from(document.querySelectorAll('.js-mega-menu'));
      this.triggers.forEach(function (trigger) {
        trigger.addEventListener('mouseover', function (e) {
          e.preventDefault();
          _this2.megaMenus.forEach(function (menu, i) {
            if (menu.dataset.menu === trigger.dataset.menu) {
              trigger.classList.add('is-active');
              menu.classList.add('is-visible');
            } else {
              _this2.triggers[i].classList.remove('is-active');
              menu.classList.remove('is-visible');
            }
          });
        });
        trigger.addEventListener('mouseleave', function () {
          _this2.megaMenus.forEach(function (menu, i) {
            _this2.triggers[i].classList.remove('is-active');
            menu.classList.remove('is-visible');
          });
        });
        trigger.parentNode.addEventListener('mouseenter', function (e) {
          e.preventDefault();
          _this2.megaMenus.forEach(function (menu) {
            velocity(menu, 'stop');
            if (menu.dataset.menu === trigger.dataset.menu) {
              velocity(menu, 'transition.slideUpIn', {
                display: 'block',
                duration: 200
              });
            } else {
              velocity(menu, 'transition.slideDownOut', {
                display: 'none',
                duration: 200
              });
            }
          });
        });
        trigger.parentNode.addEventListener('mouseleave', function () {
          _this2.megaMenus.forEach(function (menu) {
            velocity(menu, 'stop');
            velocity(menu, 'transition.slideDownOut', {
              display: 'none',
              duration: 200
            });
          });
        });
      });
    }
  }], [{
    key: "toggleFixedClasses",
    value: function toggleFixedClasses() {
      var header = document.querySelector('.js-header');
      header.classList.toggle('is-fixed');
    }
  }]);
  return Header;
}();
export { Header as default };